import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearRatesAction, clearSelectedRateAction, getRatesActions } from '../../redux/actions/ratesActions';

const useFetchRates = ({ unpaged = false }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.rates?.search);
  const rates = useSelector((state) => state.rates?.rates);
  const loading = useSelector((state) => state.rates?.loading);

  const fetchRates = useCallback(async () => {
    await dispatch(getRatesActions(search, unpaged));
  }, [search, unpaged, dispatch]);

  useEffect(() => {
    fetchRates();
  }, [fetchRates]);

  useEffect(() => {
    return () => {
      dispatch(clearRatesAction());
      dispatch(clearSelectedRateAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchRates();
  };

  return { loading, rates, refresh };
};

export default useFetchRates;
